import { defineStore } from "pinia";

export const useAppStore = defineStore("app", {
  state: () => ({
    dev: import.meta.env.DEV,
    loading: false,
    window: {
      width: 0,
      height: 0,
    },
  }),

  actions: {
    toggleLoading() {
      this.loading = !this.loading;
    },

    setLoading(value) {
      this.loading = value;
    },

    updateWindow(width, height) {
      this.window.width = width;
      this.window.height = height;
    },
  },

  getters: {
    isLoading: (state) => state.loading,
    isDev: (state) => state.dev,
    windowSize: (state) => state.window,
  },
});
